import { render, staticRenderFns } from "./UpsertCvTypeModal.vue?vue&type=template&id=4ef3cc1f&"
import script from "./UpsertCvTypeModal.vue?vue&type=script&lang=ts&"
export * from "./UpsertCvTypeModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports